// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"fd972040","782":"0981b0b3"}[chunkId] + ".chunk.css";
};